module.exports = __webpack_public_path__ + "paypal_sandbox_logo.6ac1c37fa9b6317cd307ffd52a300fec.png";